<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout>
    <v-dialog v-model="dialog" persistent max-width="530px">

      <v-card>
        <v-card color="blue">
          <v-card-title flat class='white--text subheading'>{{ 'TITLE_PEERGROUP_LOAD' | translate}}
            <v-spacer></v-spacer>
            <v-btn icon class="ma-0" @click="close"> <v-icon color="white">clear</v-icon></v-btn>
          </v-card-title>
        </v-card>
        <v-card-text>
          <!--<v-layout wrap>
            <v-flex class="mt-4">
              <v-select v-model="item"
                        :items="items"
                        item-text="bezeichnung"
                        item-value="id"
                        solo
                        :label="peergroupladen">
              </v-select>
            </v-flex>
          </v-layout>-->
          <div>
            <v-data-table
              :headers="headers"
              hide-headers
              :items="items"
              height="200"
              :pagination.sync="pagination"
              class="elevation-0 colorrows"
            >
              <template v-slot:items="props">

                <td align="left" class="pointer" @click="loadItem(props.item)" v-if="!props.item.edit">
                  <span>
                    {{props.item.bezeichnung}}
                  </span>
                </td>
                <td v-if="props.item.edit">
                  <v-text-field

                    v-model="props.item.bezeichnung"
                    label="Edit"
                    single-line
                    @change="save(props.item)"
                  >
                  </v-text-field>

                </td>

                <!--<td class="textleft">{{ props.item.name }}</td>-->
                <td class="justify-end layout">
                  <v-icon
                    @click="editTableItem(props.item)"
                    class="mx-2"
                    color="#004884"
                  >
                    edit
                  </v-icon>

                  <!---->
                  <v-icon
                    @click="askDeleteItem(props.item)"
                    class="mx-2"
                    color="#E05469"
                  >
                    delete
                  </v-icon>
                </td>
              </template>
            </v-data-table>
          </div>

        </v-card-text>
        <v-card-actions class="mx-2">
          <!--<v-btn  color="#004884" small outline dark class="text-none" @click="dialog = false">{{ 'BUTT_CANCEL' | translate}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#004884" small dark class="text-none" @click="loadItem()">{{ 'BUTT_LOAD' | translate}}</v-btn>-->
        </v-card-actions>
      </v-card>
    <!--  <v-card>
        <v-card-title class="headline">{{ $t('IEFEHLT_TITLE_PEERGROUP_LOAD')}}</v-card-title>
        <v-card-text>
          <v-layout justify-start row wrap>
            <v-flex md12>
              <v-select v-model="item"
                                :items="items"
                                item-text="bezeichnung"
                                item-value="id"
                                label="">
              </v-select>
            </v-flex>
          </v-layout>




        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" flat @click="dialog = false">{{ 'BUTT_CANCEL' | translate}}</v-btn>
          <v-btn color="darken-1" flat @click="loadItem()">{{ 'IEFEHLT_BUTT_LOAD' | translate}}</v-btn>
        </v-card-actions>
      </v-card>-->
      <v-dialog v-model="dialog2" max-width="500px">
              <v-card v-if="askItem">
          <v-card color="blue">
            <v-card-title flat class='white--text title'>{{askItem.bezeichnung}}</v-card-title>
          </v-card>

          <v-card-text>
            <v-layout justify-start row wrap>
              <v-flex md12>
                {{ 'QUESTION_DELETE_ITEM' | translate }}
              </v-flex>
            </v-layout>


          </v-card-text>
          <v-card-actions>
            <v-btn color="#004884" small dark outline class="radiusBtn text-none" @click="dialog2 = false">
              {{ 'BUTT_DELETE_ITEM_STOP' | translate }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#004884" small dark class="radiusBtn text-none"@click="deleteItem(askItem)">
              {{ 'BUTT_DELETE_ITEM' | translate }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
  </v-layout>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'DialogSelectPeergroup',
  components: {},
  data: () => ({
    peergroupladen: Vue.i18n.translate('LABLE_LOAD_PEERGROUP'),
    items: [],
    item: {},
    dialog: false,
    dialog2: false,
    askItem: null,
    pagination: {
      rowsPerPage: 10,
      descending: false,
      sortBy: 'id'
    },
    headers: [
      {
        text: Vue.i18n.translate('HEADER_LOAD_PEERGROUP'),
        align: 'left',
        sortable: false,
        value: 'bezeichnung'
      },
      { text: '', value: 'name',  align: 'left', sortable: false }
    ],
    oldItems: null,
    editedIndex: -1,
    editedItem: {
      name: ''
    },
    defaultItem: {
      name: ''
    }
  }),

  computed: {},

  watch: {
    //dialog (val) {
    //  val || this.close()
    //}
  },

  created () {
    this.initialize()
  },

  methods: {

    initialize () {
      this.items = []
    },
    open: function (items) {
      this.dialog = true
      this.items = items
      this.resetList()
      this.oldItems = JSON.parse(JSON.stringify(items))
    },
    close: function() {
      this.resetList()
      this.dialog = false
    },
    editTableItem: function (item) {
      item.edit = !item.edit
      this.items = JSON.parse(JSON.stringify(this.items))
    },
    loadItem: function (item) {
      this.dialog = false
      this.dialog2 = false
      this.$emit('doItem', item.id)
    },
    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      Vue.prototype.$api.deletePeergroupList(item.id, this.deleteDone)
    },

    deleteDone(result) {
      this.dialog2 = false
      const index = this.items.indexOf(this.askItem)
      this.items.splice(index, 1)
      this.$emit('doReload')
    },

    askDeleteItem(item) {
      console.log('askDeleteItem is done', item)
      this.askItem = item
      this.dialog2 = true
    },

    resetList() {
      if (this.items) {
        this.items.forEach((item) => {
          item.edit = false
        })
        this.items = JSON.parse(JSON.stringify(this.items))
      }
    },

    renameDone(result) {
      this.resetList()
      this.$emit('doReload', this.items)
    },

    save (item) {
      const oldEntry = this.oldItems[_.findIndex(this.oldItems, function(o) { return o.id === item.id; })]
      Vue.prototype.$api.renamePeergroupList(oldEntry.id, item.bezeichnung, this.renameDone)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogSelectPeergroup.vue